import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import React from 'react'
import { useToggle } from 'react-use'

import agent from 'agent'
import Icon from 'components/Icon'
import useAuth from 'hooks/use-auth'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export const DeleteServiceGoldenSignal: React.FC<{
  goldenSignalId: string
  goldenSignalName: string
  onChanged: () => void
  disabled?: boolean
}> = ({ goldenSignalId, onChanged, goldenSignalName, disabled }) => {
  const { currentTeamId } = useAuth()
  const [isModalOpen, setIsModalOpen] = useToggle(false)

  const deleteGoldenSignal = async () => {
    try {
      await agent.delete(
        `status-checks/${goldenSignalId}?teamId=${currentTeamId}`
      )
      setIsModalOpen(false)
      onChanged()
      toast({ type: 'success', text: 'Golden signal removed successfully' })
    } catch (err) {
      const message = messageFromResponseError(
        err,
        'There was an error while removing the Golden Signal. Please try again later.'
      )
      toast({ type: 'error', text: message })
    }
  }

  return (
    <>
      <Button
        color="error"
        data-testid={`delete-service-status-check-${goldenSignalId}-button`}
        disabled={disabled}
        startIcon={<Icon icon="trash" />}
        variant="contained"
        onClick={() => setIsModalOpen(true)}
      >
        Delete
      </Button>
      <Dialog
        data-testid="delete-service-status-check-dialog"
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DialogTitle
          color="error"
          data-testid="delete-service-status-check-dialog-title"
        >
          Delete Golden Signal?
        </DialogTitle>
        <DialogContent data-testid="delete-service-status-check-dialog-content">
          <DialogContentText>
            {goldenSignalName} will be deleted
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            data-testid="delete-service-status-check-dialog-cancel"
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            data-testid="delete-service-status-check-dialog-submit"
            onClick={deleteGoldenSignal}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
